import { render, staticRenderFns } from "./LeadsUnderManagementCard.vue?vue&type=template&id=2fe4ed92&scoped=true&"
import script from "./LeadsUnderManagementCard.vue?vue&type=script&lang=js&"
export * from "./LeadsUnderManagementCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadsUnderManagementCard.vue?vue&type=style&index=0&id=2fe4ed92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4ed92",
  null
  
)

export default component.exports